import debounce from "lodash.debounce";
import { useCallback, useEffect, useMemo, useRef } from "react";

const useScrollLoading = (cb) => {
  const scrollRef = useRef(null);

  const debouncedOnScroll = useMemo(
    () =>
      debounce(() => {
        if (scrollRef.current) {
          const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
          const SCROLL_THRESHOLD = 100;

          if (scrollHeight - (scrollTop + clientHeight) < SCROLL_THRESHOLD) {
            cb();
          }
        }
      }, 100),
    [cb],
  );

  useEffect(() => {
    return () => debouncedOnScroll.cancel();
  }, [debouncedOnScroll]);

  const onScroll = useCallback(() => {
    debouncedOnScroll();
  }, [debouncedOnScroll]);

  return { scrollRef, onScroll };
};

export { useScrollLoading };
